import React, { useState } from "react";
import { useSelector } from "react-redux";


import { useTranslation } from "react-i18next";

import { Accordion } from "react-bootstrap";
import { Spin, Tooltip } from "antd";
import config from "../../../helper/config";


const WatchCustomizer = () => {
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [loading, setLoading] = useState(true);
  if (loginDetials) {
    if (loginDetials.responseData) {
      if (loginDetials.responseData.logInSucceeded) {
      }
    }
  }

  const src = `${config.WatchCustomizerURL}/?DealerLink=${loginDetials.responseData.dealerId}&Track=0`;
  const hideSpinner = () => {
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Spin spinning={loading}>
        <iframe
          onLoad={() => hideSpinner()}
          width="100%"
          className="application__preview"
          //height="1000px"
          src={src}
        ></iframe>
      </Spin>
    </React.Fragment>
  );
};

export default WatchCustomizer;
